// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".business-layout{background:#f8fafb}.business-layout .app-header__navbar{display:none}", ""]);
// Exports
module.exports = exports;
